(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    function positionFlowGuarantees() {
    document.querySelectorAll('.product-form-buttons .flow-bros-guarantee').forEach((guarantee) => {
      const buttons = guarantee.closest('.product-form-buttons');
      if (buttons.dataset.guaranteePositioned) return;
      buttons.dataset.guaranteePositioned = 'true';
      const place = () => {
        const button = buttons.querySelector('button[name="add"]');
        if (button && button.previousElementSibling !== guarantee) {
          button.before(guarantee);
        }
      };
      place();
      new MutationObserver(place).observe(buttons, { childList: true, subtree: true });
    });
  }
  positionFlowGuarantees();
  document.addEventListener('shopify:section:load', positionFlowGuarantees);
  } catch(e) { console.error(e); }
})();

})();
